export async function fetchBanDetailById(id: number) {
  return http.get<BlackroomDetail>('/v1/black_room/get', { id })
}
